import React from "react";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

const Link = styled(({ ...rest }) => <GatsbyLink {...rest} rel="" />)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 100%;
  height: 100%;
`;

const ExternalLink = styled(({ ...rest }) => <a {...rest} rel="" target="blank" />)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 100%;
  height: 100%;
`;

export default Link;

export { ExternalLink }
